<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="saveEdition">
              <h2>Atualizar</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Placa</label>
                <input
                  type="text"
                  placeholder="XX123"
                  class="form-control"
                  v-model="registerForm.form.licencePlate"
                />
              </div>

              <br /><br />
              <div v-if="selectedVehicle">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  @click="cancelEdition"
                >
                  Cancelar
                </button>
                <button
                  class="btn btn-primary pull-right"
                  href="mail_compose.html"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Placas</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.licencePlate"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchVehicles"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Placa</th>

                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in vehicleList" :key="listIdx">
                <td>{{ listItem.licencePlate }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Inabilitar funcionário"
                    v-if="permissionUpdate"
                    @click="selectVehicle(listItem)"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from '@/plugins/toast';
export default {
  name: 'Vehicles',

  data() {
    return {
      registerForm: {
        form: {
          licencePlate: '',
        },
      },
      searchForm: {
        form: {
          licencePlate: '',
        },
        control: {},
      },
      vehicleList: [],
      selectedVehicle: '',
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('vehicles', 'CREATE');
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('vehicles', 'READ');
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('vehicles', 'UPDATE');
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('vehicles', 'DELETE');
    },
  },

  methods: {
    async searchVehicles() {
      try {
        if (!this.permissionRead) {
          return;
        }
        if (!this.searchForm.form.licencePlate) {
          return;
        }
        const vehicleList = await this.$store.dispatch(
          'VEHICLE/ListLicencePlates',
          this.searchForm.form.licencePlate,
        );

        this.vehicleList = vehicleList.licencePlates;
      } catch (error) {
        toast.error('Não foi possível listar as placas');
      }
    },

    selectVehicle({ _id, licencePlate }) {
      this.selectedVehicle = _id;
      this.registerForm.form.licencePlate = licencePlate;
    },
    cancelEdition() {
      this.selectedVehicle = '';
      this.registerForm.form.licencePlate = '';
    },
    async saveEdition() {
      const payload = {
        vehicleId: this.selectedVehicle,
        licencePlate: this.registerForm.form.licencePlate,
      };
      try {
        await this.$store.dispatch('VEHICLE/UpdateLicencePlate', payload);
        this.searchVehicles();
        this.cancelEdition();
        toast.success('Placa atualizada com sucesso');
      } catch (error) {
        console.error(error);
        toast.error('Falha ao atualizar placa');
      }
    },
  },
};
</script>